namespace TabAurous.Finance {
    export interface ExpenseDetailRow {
        TransDetailsId?: number;
        TransId?: number;
        LedgerId?: number;
        PartyType?: string;
        LedgerName?: string;
        Amount?: number;
        ExchangeRateId?: number;
        ChequeNo?: string;
        ChequeDate?: string;
        Mode?: string;
        TaxId?: number;
        TaxName?: string;
        TaxAmount?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace ExpenseDetailRow {
        export const idProperty = 'TransDetailsId';
        export const localTextPrefix = 'Finance.ExpenseDetail';
        export const deletePermission = 'Finance:Expense:Delete';
        export const insertPermission = 'Finance:Expense:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:Expense:Edit';

        export declare const enum Fields {
            TransDetailsId = "TransDetailsId",
            TransId = "TransId",
            LedgerId = "LedgerId",
            PartyType = "PartyType",
            LedgerName = "LedgerName",
            Amount = "Amount",
            ExchangeRateId = "ExchangeRateId",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Mode = "Mode",
            TaxId = "TaxId",
            TaxName = "TaxName",
            TaxAmount = "TaxAmount",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
